<template>
  <div></div>
</template>

<script>
export default {
  name: 'refresh',
  data () {
    return {
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$router.replace({path:from.path,query:from.query})
    })
  }
}

</script>
<style scoped>
</style>
